import React, { FC, useState } from "react";
import DataGrid, { GridSortItem } from "../../Unknown/DataGrid";
import useDashboardColumns, {
  DashboardColumnsParams,
} from "./useDashboardColumns";
import { AppointmentAIReportRowItem } from "./types";
import useStyles from "./useStyles";
import AppointmentAIReportsTableTopBar, {
  ShowApprovedSwitchProps,
} from "../AppointmentAIReportsTableTopBar";
import { PAGE_SIZE_OPTIONS } from "../../../common/constants";

type AppointmentAIReportsTableGridProps = {
  columnsConfig: DashboardColumnsParams;
  rows: AppointmentAIReportRowItem[];
  isLoading?: boolean;
  showApprovedProps: ShowApprovedSwitchProps;
  sortModel: GridSortItem[];
  setSortModel: (newModel: GridSortItem[]) => void;
};

const AppointmentAIReportsTableGrid: FC<AppointmentAIReportsTableGridProps> = ({
  columnsConfig,
  rows,
  isLoading,
  showApprovedProps,
  sortModel,
  setSortModel,
}) => {
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: PAGE_SIZE_OPTIONS[0],
  });

  const { root } = useStyles();

  const columns = useDashboardColumns(columnsConfig);

  const onSortModelChange = (newModel: GridSortItem[]) => {
    setSortModel(newModel);
  };

  return (
    <DataGrid
      autoHeight
      getRowHeight={() => "auto"}
      rows={rows}
      columns={columns}
      disableRowSelectionOnClick
      loading={isLoading}
      className={root}
      sortModel={sortModel}
      pagination
      onSortModelChange={onSortModelChange}
      paginationModel={paginationModel}
      onPaginationModelChange={(newModel) => setPaginationModel(newModel)}
      slots={{
        toolbar: AppointmentAIReportsTableTopBar,
      }}
      slotProps={{
        toolbar: { showApprovedProps },
      }}
      pageSizeOptions={PAGE_SIZE_OPTIONS}
    />
  );
};

export default AppointmentAIReportsTableGrid;
